import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import { NpsPublicFormResponse } from '@/Network/Types/Responses/NpsPublicFormResponses'
import { SubmitNpsPublic } from '@/Network/Types/Requests/NpsRequests'

export default class NpsPublicFormService extends Service {
  prefix = '/nps/public'

  async getForm(healthUnitId: number, surveyId?: number): Promise<NpsPublicFormResponse> {
    const params = surveyId ? { surveyId } : undefined
    const { data } = await request.get<NpsPublicFormResponse | NpsPublicFormResponse[]>(
      `${this.getCompletePath()}/health-unit/${healthUnitId}`,
      params
    )
    if (Array.isArray(data)) {
      if (data.length === 0)
        throw new Error('Nenhum formulário vigente encontrado para esta unidade.')
      return data[0]
    }
    return data
  }

  async submit(payload: SubmitNpsPublic): Promise<{ submissionId: number; answersCount: number }> {
    const { data } = await request.post<{ submissionId: number; answersCount: number }>(
      `${this.getCompletePath()}/submit`,
      payload
    )
    return data
  }
}
